/**
 * Mobile Header Component
 * 
 * Phase 1A: Sticky header with optional back button and actions.
 */
import { ArrowLeft, RefreshCw, LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function MobileHeader({ 
  title, 
  subtitle,
  onBack, 
  onRefresh, 
  refreshing = false,
  showLogout = false,
  onLogout,
  actions = [] 
}) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <header className="sticky top-0 z-40 bg-slate-800 border-b border-slate-700 px-4 py-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          {onBack !== undefined && (
            <button
              onClick={handleBack}
              className="p-2 rounded-lg bg-slate-700 hover:bg-slate-600 active:scale-95 transition-all min-w-[44px] min-h-[44px] flex items-center justify-center"
              data-testid="header-back"
            >
              <ArrowLeft className="w-5 h-5 text-white" />
            </button>
          )}
          <div>
            <h1 className="text-lg font-bold text-white">{title}</h1>
            {subtitle && (
              <p className="text-xs text-slate-400">{subtitle}</p>
            )}
          </div>
        </div>
        
        <div className="flex items-center gap-2">
          {actions.map((action, idx) => (
            <button
              key={idx}
              onClick={action.onClick}
              disabled={action.disabled}
              className="p-2 rounded-lg bg-slate-700 hover:bg-slate-600 active:scale-95 transition-all min-w-[44px] min-h-[44px] flex items-center justify-center disabled:opacity-50"
              data-testid={action.testId}
            >
              {action.icon}
            </button>
          ))}
          
          {onRefresh && (
            <button
              onClick={onRefresh}
              disabled={refreshing}
              className="p-2 rounded-lg bg-slate-700 hover:bg-slate-600 active:scale-95 transition-all min-w-[44px] min-h-[44px] flex items-center justify-center disabled:opacity-50"
              data-testid="header-refresh"
            >
              <RefreshCw className={`w-5 h-5 text-white ${refreshing ? "animate-spin" : ""}`} />
            </button>
          )}
          
          {showLogout && onLogout && (
            <button
              onClick={onLogout}
              className="p-2 rounded-lg bg-red-600 hover:bg-red-700 active:scale-95 transition-all min-w-[44px] min-h-[44px] flex items-center justify-center"
              data-testid="header-logout"
            >
              <LogOut className="w-5 h-5 text-white" />
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
